import { render, staticRenderFns } from "./orderDetail.vue?vue&type=template&id=7041176a&scoped=true"
import script from "./orderDetail.vue?vue&type=script&lang=js"
export * from "./orderDetail.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/order/orderDetail.css?vue&type=style&index=0&id=7041176a&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7041176a",
  null
  
)

export default component.exports